import React from 'react';
import { BookOpenIcon, GiftIcon, CheckIcon } from 'lucide-react';
export function ProcessSection() {
  return <section className="bg-navy text-white py-20 px-4" data-id="element-133">
      <div className="max-w-5xl mx-auto" data-id="element-134">
        <h2 className="text-3xl md:text-4xl font-heading font-bold mb-16 text-center" data-id="element-135">
          ¿Qué incluye el Ebook?
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-136">
          {/* Modules */}
          <div className="space-y-6" data-id="element-137">
            <h3 className="text-2xl font-bold text-green mb-6 flex items-center" data-id="element-138">
              <BookOpenIcon className="mr-3" data-id="element-139" /> Programa Principal
            </h3>

            <div className="bg-navy-dark p-6 rounded-xl border border-gray-800" data-id="element-140">
              <h4 className="font-bold text-lg mb-2 text-white" data-id="element-141">
                Módulo 1: Entendiendo el sistema
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-142">
                Cómo funciona realmente el crédito en USA y qué miran los
                bancos.
              </p>
            </div>

            <div className="bg-navy-dark p-6 rounded-xl border border-gray-800" data-id="element-143">
              <h4 className="font-bold text-lg mb-2 text-white" data-id="element-144">
                Módulo 2: Cómo comenzar desde cero
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-145">
                El paso a paso exacto para abrir tu primer producto de crédito
                sin ser rechazado.
              </p>
            </div>

            <div className="bg-navy-dark p-6 rounded-xl border border-gray-800" data-id="element-146">
              <h4 className="font-bold text-lg mb-2 text-white" data-id="element-147">
                Módulo 3: Cómo subir el score más rápido
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-148">
                Estrategias comprobadas para acelerar tu crecimiento crediticio
                legalmente.
              </p>
            </div>

            <div className="bg-navy-dark p-6 rounded-xl border border-gray-800" data-id="element-149">
              <h4 className="font-bold text-lg mb-2 text-white" data-id="element-150">
                Módulo 4: Errores que destruyen el crédito
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-151">
                Las trampas comunes que debes evitar a toda costa para proteger
                tu perfil.
              </p>
            </div>

            <div className="bg-navy-dark p-6 rounded-xl border border-gray-800" data-id="element-152">
              <h4 className="font-bold text-lg mb-2 text-white" data-id="element-153">
                Módulo 5: Perfil financiero fuerte
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-154">
                Cómo prepararte para solicitar préstamos grandes (autos,
                hipotecas) con éxito.
              </p>
            </div>
          </div>

          {/* Bonuses */}
          <div data-id="element-155">
            <div className="bg-gradient-to-br from-green-hover to-green p-8 rounded-2xl shadow-2xl text-white sticky top-8" data-id="element-156">
              <h3 className="text-2xl font-bold mb-6 flex items-center" data-id="element-157">
                <GiftIcon className="mr-3" data-id="element-158" /> Bonus Exclusivos
              </h3>

              <ul className="space-y-6" data-id="element-159">
                <li className="flex items-start" data-id="element-160">
                  <CheckIcon className="w-6 h-6 mr-3 flex-shrink-0 text-white" data-id="element-161" />
                  <div data-id="element-162">
                    <strong className="block text-lg" data-id="element-163">
                      Checklist Método 700+
                    </strong>
                    <span className="text-green-light text-sm" data-id="element-164">
                      Una lista de verificación para asegurar que cumples cada
                      paso.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-165">
                  <CheckIcon className="w-6 h-6 mr-3 flex-shrink-0 text-white" data-id="element-166" />
                  <div data-id="element-167">
                    <strong className="block text-lg" data-id="element-168">
                      Plan de acción de 90 días
                    </strong>
                    <span className="text-green-light text-sm" data-id="element-169">
                      Tu hoja de ruta exacta para tus primeros 3 meses.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-170">
                  <CheckIcon className="w-6 h-6 mr-3 flex-shrink-0 text-white" data-id="element-171" />
                  <div data-id="element-172">
                    <strong className="block text-lg" data-id="element-173">
                      Estrategia de crecimiento financiero
                    </strong>
                    <span className="text-green-light text-sm" data-id="element-174">
                      Cómo usar tu nuevo crédito para generar riqueza.
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}